import React, { useEffect, useState } from "react";

const HasAllergiesQuestion = ({ onSubmit, onNext, initialValue }) => {
    const [hasAllergies, setHasAllergies] = useState("");

    // Pre-fill when editing
    useEffect(() => {
        if (initialValue) {
            // Handle both "y"/"n" string format and boolean format
            if (typeof initialValue === "string") {
                setHasAllergies(initialValue);
            } else if (typeof initialValue === "boolean") {
                setHasAllergies(initialValue ? "y" : "n");
            } else if (typeof initialValue === "object" && initialValue.has) {
                setHasAllergies(initialValue.has);
            }
        }
    }, [initialValue]);

    const handleSelect = (value, event) => {
        // Blur the button after click to prevent focus from persisting and looking like selection
        if (event && event.currentTarget) {
            event.currentTarget.blur();
        }
        setHasAllergies(value);
        // Don't call onSubmit here - only when Continue is clicked
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        
        if (!hasAllergies) return;
        
        onSubmit(hasAllergies);
        onNext();
        
        // Reset selection
        setHasAllergies("");
    };

    const canSubmit = hasAllergies !== "";

    return (
        <form onSubmit={handleSubmit} className="input-form">
            <div className="treatment-options-container">
                <div className="treatment-options" style={{ justifyContent: "center" }}>
                    <button
                        type="button"
                        className={`treatment-button ${hasAllergies === "y" ? "treatment-button-selected" : ""}`}
                        onClick={(e) => handleSelect("y", e)}
                    >
                        Yes
                    </button>
                    <button
                        type="button"
                        className={`treatment-button ${hasAllergies === "n" ? "treatment-button-selected" : ""}`}
                        onClick={(e) => handleSelect("n", e)}
                    >
                        No
                    </button>
                </div>
                <button
                    type="submit"
                    className="treatment-submit-button"
                    disabled={!canSubmit}
                >
                    Continue
                </button>
            </div>
        </form>
    );
};

export default HasAllergiesQuestion;

